<template>
  <div class="index">
    <container></container>
    <map-ability></map-ability>
  </div>
</template>

<script>
import container from './components/container';
import MapAbility from './components/MapAbility';
export default {
  name: 'index',
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {},
  components: {
    container,
    MapAbility
  }
};
</script>

<style scoped lang="scss">
.index {
  height: 100vh;
}
</style>
